import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SubscriptionLike } from 'rxjs';
import { ConsultService } from './consult.service';
import { CartService } from './cart/cart.service';
import $ from './lib/jquery';
import UIkit from './lib/uikit';

@Component({
  selector: 'header-basket',
  templateUrl: '../templates/header-basket.component.html',
  styleUrls: ['../styles/components/header-basket.component.less']
})
export class HeaderBasketComponent implements OnInit, OnDestroy, AfterViewInit {
  subscription: SubscriptionLike;
  dropdown: any;

  constructor(
    private el: ElementRef,
    public cartService: CartService,
    private consult: ConsultService,
    private router: Router,
  ) {}

  public ngOnInit() {
    this.subscription = this.router.events.subscribe((e) => {
      if (!(e instanceof NavigationEnd)) return;
      if (typeof window !== 'undefined') this.dropdown.hide();
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public ngAfterViewInit() {
    if (typeof window === 'undefined') return;

    const block = $(this.el.nativeElement);
    const menu = block.find('#HeaderBasket_Menu');
    this.dropdown = UIkit.dropdown(menu, {
      mode: 'click',
      pos: 'bottom-right',
      animation: 'uk-animation-slide-top'
    });
  }

  get totalQuantity() {
    if (!this.cartService.cart) return 0;
    return this.cartService.cart.ITEMS.reduce((total, item) => {
      return total + item.QUANTITY;
    }, 0);
  }

  get totalCurrency() {
    return (this.cartService.cart && this.cartService.cart.ITEMS.length > 0) ?
      this.cartService.cart.ITEMS[0].PROVIDER_DATA.CURRENCY :
      'RUB';
  }

  public async deleteFromCart(id: number) {
    try {
      const res = await this.cartService.delete(id);
      this.consult.notification({
        name: res.message,
        status: 'success',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
    } catch (e) {
      this.consult.notification({
        name: e.message,
        status: 'danger',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
    }
  }
}
